import React from 'react';
import styled from 'styled-components';

import Heading from '../../../../../shared/components/Heading';
import HeroGradientHeading from '../../../../../shared/components/Heading/HeroGradientHeading';

import { typography, spaces } from '../../../../../shared/lib/styles';
import { between } from '../../../../../shared/spa/core-components/utils/media';

export const Paragraph = styled.p`
    margin: ${spaces.space4}px 0 ${spaces.space4}px ${spaces.space10}px;
    max-width: 40em;
    font-size: ${typography.typeScale.size4}px;

    ${between('small', 'medium')} {
        font-size: ${typography.typeScale.size3}px;
        margin-left: 0;
    }
`;

interface Props {
    titlePrefix: string;
    headingGradient: string[];
    title: string;
    description: string;
}

export default function HeroHeadingText({
    titlePrefix,
    headingGradient,
    title,
    description,
}: Props) {
    return (
        <>
            <Heading type="h4" variations={['h4', 'no-margin']}>
                {titlePrefix}
            </Heading>
            <HeroGradientHeading gradient={headingGradient}>{title}</HeroGradientHeading>
            <Paragraph>{description}</Paragraph>
        </>
    );
}
